import { queryCollection, useRequestEvent } from '#imports'
import { createLayeredContent, type LayeredContent } from '@content-base/server/utils/layeredContent'

export function useLayeredContent(): LayeredContent {
    return useRequestEvent()?.context.layeredContent ?? createLayeredContent(collection => queryCollection(collection as never), { cascade: true })
}

export default useLayeredContent
